if (typeof jQuery != "undefined") {
    (function($) {
        "use strict";

        /** Declaration uploader
         * Functionality for uploading declarations
         *
         *
         *
         * @param form - jQuery object of containing (sub)form (not required to be of <form> element)
         */
        ZZ.ExtendedDeclarationUploader = function(form) {
            var base = this;
            base.form = form;

            base.items = [];
            base.totalFilessize = 0;
            base.activeItem = 0;

            base.listFileuploaders = base.form.find(".fileupload");
            base.FileApiSupported = !!(
                window.File &&
                window.FileReader &&
                window.FileList &&
                window.Blob
            );

            base.initFileUploader();
        };

        ZZ.ExtendedDeclarationUploader.prototype = {
            initFileUploader: function() {
                var base = this;
                var items = base.listFileuploaders;
                for (var i = 0, length = items.length; i < length; i++) {
                    var item = new ZZ.SimpleDeclarationUploader($(items[i]));
                    base.items.push($(items[i]));
                    if (base.FileApiSupported) {
                        item.fileinputContainer.bind(
                            "ZZ_file_chosen",
                            base.fileChosen.bind(base, item)
                        );
                        item.fileinputContainer.bind(
                            "ZZ_file_removed",
                            base.fileRemoved.bind(base, item)
                        );
                        if (i > base.activeItem) {
                            $(items[i]).hide();
                        }
                    }
                }
            },

            fileChosen: function(item, event) {
                this.totalFilessize = this.totalFilessize + item.fileSize;

                if (this.activeItem !== this.listFileuploaders.length - 1) {
                    if (this.totalFilessize <= 5) {
                        this.items[this.activeItem + 1].show();
                        this.activeItem++;
                    }

                    if (this.totalFilessize > 5) {
                        item.deleteBtn.trigger("click");
                        item.showFileSizeError();
                    }
                }
            },

            fileRemoved: function(item, event) {
                this.totalFilessize = this.totalFilessize - item.fileSize;

                if (this.totalFilessize <= 5) {
                    for (
                        var i =
                            this.form.find(".size-validation-message").length -
                            1;
                        i >= 0;
                        i--
                    ) {
                        $(this.form.find(".size-validation-message")[i]).hide();
                    }
                }
            },

            formsubmit: function(event) {
                this.submitBtn.attr("disabled", "disabled");
            }
        };
    })(jQuery);
}
